export const OnlyNumericCommaAndDotInputOnKeypress = (e) => {
    let char = String.fromCharCode(e.keyCode);
    let regex = /[0-9]|\.|,/;
    if (!regex.test(char)) {
        e.preventDefault();
    }
}